import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// dispatcher
const dispatcher = r => require.ensure([], () => r(require('../page/dispatcher')), 'dispatcher')
// demo
const helloWorld = r => require.ensure([], () => r(require('../page/demo/helloWorld')), 'helloWorld')
const messageList = r => require.ensure([], () => r(require('../page/message/list')), 'list')
const rateInfo = r => require.ensure([], () => r(require('../page/rate/info')), 'info')
const companyInfo = r => require.ensure([], () => r(require('../page/company/info')), 'companyInfo')
const questions = r => require.ensure([], () => r(require('../page/help/questions')), 'questions')
const questionDetail = r => require.ensure([], () => r(require('../page/help/questionDetail')), 'questionDetail')
const feedback = r => require.ensure([], () => r(require('../page/help/feedback')), 'feedback')
const privacyPolicyInfo = r => require.ensure([], () => r(require('../page/privacyPolicy/info')), 'privacyPolicyInfo')
const regulationInfo = r => require.ensure([], () => r(require('../page/regulation/info')), 'regulationInfo')
const expensesInfo = r => require.ensure([], () => r(require('../page/charge/info')), 'expensesInfo')
const provisionNumber = r => require.ensure([], () => r(require('../page/provisionNumber/info')), 'provisionNumber')
const provisionNumberHK = r => require.ensure([], () => r(require('../page/provisionNumber/InfoHk')), 'provisionNumberHK')
const provisionNumberCN = r => require.ensure([], () => r(require('../page/provisionNumber/InfoCn')), 'provisionNumberCN')
const balanceRecharge = r => require.ensure([], () => r(require('../page/balanceRecharge/info')), 'balanceRecharge')
const paySuccess = r => require.ensure([], () => r(require('../components/common/paySuccess')), 'paySuccess')
const payFail = r => require.ensure([], () => r(require('../components/common/payFail')), 'payFail')
const realNameVerify = r => require.ensure([], () => r(require('../page/realNameVerify/info')), 'realNameVerify')
const realNameSuccess = r => require.ensure([], () => r(require('../page/realNameVerify/success')), 'realNameSuccess')
const provisionHK = r => require.ensure([], () => r(require('../page/esBusiness/provisionHK/index')), 'provisionHK')
const tokenFail = r => require.ensure([], () => r(require('../components/common/tokenFail')), 'tokenFail')
const ordinaryNumCN = r => require.ensure([], () => r(require('../page/esBusiness/provisionCN/ordinaryNum')), 'ordinaryNum')
const buyRecord = r => require.ensure([], () => r(require('../page/buyRecord/info')), 'buyRecord')
const addPackagePlan = r => require.ensure([], () => r(require('../page/esBusiness/addPackagePlan/info')), 'addPackagePlan')
const smartSIMHK = r => require.ensure([], () => r(require('../page/esBusiness/smartSIMHK/index')), 'smartSIMHK')
const specialCnNumber = r => require.ensure([], () => r(require('../page/esBusiness/specialCnNumber/index')), 'specialCnNumber')
const provisionOversea = r => require.ensure([], () => r(require('../page/provisionOversea/info')), 'provisionOversea')
const ukPlan = r => require.ensure([], () => r(require('../page/esBusiness/ukPlan/index')), 'ukPlan')
const myProduct = r => require.ensure([], () => r(require('../page/myProduct/index')), 'myProduct')
const traveleSimPlan = r => require.ensure([], () => r(require('../page/esBusiness/traveleSimPlan/index')), 'traveleSimPlan')
const toTraveleSimInfo = r => require.ensure([], () => r(require('../page/esBusiness/traveleSimPlan/info')), 'toTraveleSimInfo')
const eSimTopUp = r => require.ensure([], () => r(require('../page/esBusiness/eSimTopUp/index')), 'eSimTopUp')
const payErrorJumpPage = r => require.ensure([], () => r(require('../components/common/payErrorJumpPage')), 'payErrorJumpPage')
const gsrateInfo = r => require.ensure([], () => r(require('../page/gs/rate/info')), 'gsrateInfo')
const gscompanyInfo = r => require.ensure([], () => r(require('../page/gs/company/info')), 'gscompanyInfo')
const gsquestions = r => require.ensure([], () => r(require('../page/gs/help/questions')), 'gsquestions')
const gsquestionDetail = r => require.ensure([], () => r(require('../page/gs/help/questionDetail')), 'gsquestionDetail')
const gsfeedback = r => require.ensure([], () => r(require('../page/gs/help/feedback')), 'gsfeedback')
const gsprivacyPolicyInfo = r => require.ensure([], () => r(require('../page/gs/privacyPolicy/info')), 'gsprivacyPolicyInfo')
const gsregulationInfo = r => require.ensure([], () => r(require('../page/gs/regulation/info')), 'gsregulationInfo')
const gsexpensesInfo = r => require.ensure([], () => r(require('../page/gs/charge/info')), 'gsexpensesInfo')
const esOfficialGroup = r => require.ensure([], () => r(require('../page/esOfficialGroup/info')), 'esOfficialGroup')
const gsOfficialGroup = r => require.ensure([], () => r(require('../page/gs/gsOfficialGroup/info')), 'gsOfficialGroup')
const gsBindICCID = r => require.ensure([], () => r(require('../page/gs/business/gsBindICCID/info')), 'gsBindICCID')
const gsPaySuccess = r => require.ensure([], () => r(require('../components/common/gs/paySuccess')), 'gsPaySuccess')
const gsPayFail = r => require.ensure([], () => r(require('../components/common/gs/payFail')), 'gsPayFail')
const esDeleteUserData = r => require.ensure([], () => r(require('../page/esDeleteUserData/info')), 'esDeleteUserData')
const gsDeleteUserData = r => require.ensure([], () => r(require('../page/gs/gsDeleteUserData/info')), 'gsDeleteUserData')
const notice = r => require.ensure([], () => r(require('../page/notice/index')), 'notice')
const brandHKNew = r => require.ensure([], () => r(require('../page/esBusiness/brandHKNew/index')), 'brandHKNew')
const polPlan = r => require.ensure([], () => r(require('../page/esBusiness/polPlan/index')), 'polPlan')
const usPlan = r => require.ensure([], () => r(require('../page/esBusiness/usPlan/index')), 'usPlan')
const esContactUs = r => require.ensure([], () => r(require('../page/help/esContactUs')), 'esContactUs')
const realNameInfo = r => require.ensure([], () => r(require('../page/realNameInfo/info')), 'realNameInfo')
const WhatsAppJumpTo = r => require.ensure([], () => r(require('../page/help/WhatsAppJumpTo')), 'WhatsAppJumpTo')
const FacebookJump = r => require.ensure([], () => r(require('../page/help/FacebookJump')), 'FacebookJump')
const WechatJump = r => require.ensure([], () => r(require('../page/help/WechatJump')), 'WechatJump')
const RussianJump = r => require.ensure([], () => r(require('../page/help/RussianJump')), 'RussianJump')
const WeChatBussinessJump = r => require.ensure([], () => r(require('../page/help/WeChatBussinessJump')), 'WeChatBussinessJump')
const appRouter = {
  // mode: 'history',
  routes: [
    {
      path: '',
      name: 'dispatcher',
      component: dispatcher
    },
    {
      path: '/hello',
      name: 'hello',
      component: helloWorld
    },
    {
      path: '/messageList',
      name: 'messageList',
      component: messageList,
      meta: {keepAlive: false}
    },
    {
      path: '/rate',
      name: 'rateInfo',
      component: rateInfo,
      meta: {keepAlive: false}
    },
    {
      path: '/privacyPolicyInfo',
      name: 'privacyPolicyInfo',
      component: privacyPolicyInfo
    },
    {
      path: '/companyInfo',
      name: 'companyInfo',
      component: companyInfo
    },
    {
      path: '/questions',
      name: 'questions',
      component: questions
    },
    {
      path: '/questionDetail',
      name: 'questionDetail',
      component: questionDetail
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/regulationInfo',
      name: 'regulationInfo',
      component: regulationInfo
    },
    {
      path: '/expensesInfo',
      name: 'expensesInfo',
      component: expensesInfo
    },
    {
      path: '/provisionNumber',
      name: 'provisionNumber',
      component: provisionNumber
    },
    {
      path: '/provisionNumberHK',
      name: 'provisionNumberHK',
      component: provisionNumberHK
    },
    {
      path: '/provisionNumberCN',
      name: 'provisionNumberCN',
      component: provisionNumberCN
    },
    {
      path: '/balanceRechargeV2',
      name: 'balanceRecharge',
      component: balanceRecharge
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: paySuccess
    },
    {
      path: '/payFail',
      name: 'payFail',
      component: payFail
    },
    {
      path: '/realNameVerify',
      name: 'realNameVerify',
      component: realNameVerify
    },
    {
      path: '/provisionHK',
      name: 'provisionHK',
      component: provisionHK
    },
    {
      path: '/realNameSuccess',
      name: 'realNameSuccess',
      component: realNameSuccess
    },
    {
      path: '/tokenFail',
      name: 'tokenFail',
      component: tokenFail
    },
    {
      path: '/ordinaryNumCN',
      name: 'ordinaryNumCN',
      component: ordinaryNumCN
    },
    {
      path: '/buyRecord',
      name: 'buyRecord',
      component: buyRecord
    },
    {
      path: '/addPackagePlan',
      name: 'addPackagePlan',
      component: addPackagePlan
    },
    {
      path: '/smartSIMHK',
      name: 'smartSIMHK',
      component: smartSIMHK
    },
    {
      path: '/specialCnNumber',
      name: 'specialCnNumber',
      component: specialCnNumber
    },
    {
      path: '/provisionOversea',
      name: 'provisionOversea',
      component: provisionOversea
    },
    {
      path: '/ukPlanNew',
      name: 'ukPlan',
      component: ukPlan
    },
    {
      path: '/myProduct',
      name: 'myProduct',
      component: myProduct
    },
    {
      path: '/traveleSimPlan',
      name: 'traveleSimPlan',
      component: traveleSimPlan
    },
    {
      path: '/eSimTopUp',
      name: 'eSimTopUp',
      component: eSimTopUp
    },
    {
      path: '/toTraveleSimInfo',
      name: 'toTraveleSimInfo',
      component: toTraveleSimInfo
    },
    {
      path: '/payerrorjump',
      name: 'payerrorjump',
      component: payErrorJumpPage
    },
    {
      path: '/gsrate',
      name: 'gsrateInfo',
      component: gsrateInfo
    },
    {
      path: '/gscompanyInfo',
      name: 'gscompanyInfo',
      component: gscompanyInfo
    },
    {
      path: '/gsquestions',
      name: 'gsquestions',
      component: gsquestions
    },
    {
      path: '/gsquestionDetail',
      name: 'gsquestionDetail',
      component: gsquestionDetail
    },
    {
      path: '/gsfeedback',
      name: 'gsfeedback',
      component: gsfeedback
    },
    {
      path: '/gsprivacyPolicyInfo',
      name: 'gsprivacyPolicyInfo',
      component: gsprivacyPolicyInfo
    },
    {
      path: '/gsregulationInfo',
      name: 'gsregulationInfo',
      component: gsregulationInfo
    },
    {
      path: '/gsexpensesInfo',
      name: 'gsexpensesInfo',
      component: gsexpensesInfo
    },
    {
      path: '/esOfficialGroup',
      name: 'esOfficialGroup',
      component: esOfficialGroup
    },
    {
      path: '/gsOfficialGroup',
      name: 'gsOfficialGroup',
      component: gsOfficialGroup
    },
    {
      path: '/gsBindICCID',
      name: 'gsBindICCID',
      component: gsBindICCID
    },
    {
      path: '/gsPaySuccess',
      name: 'gsPaySuccess',
      component: gsPaySuccess
    },
    {
      path: '/gsPayFail',
      name: 'gsPayFail',
      component: gsPayFail
    },
    {
      path: '/gsDeleteUserData',
      name: 'gsDeleteUserData',
      component: gsDeleteUserData
    },
    {
      path: '/esDeleteUserData',
      name: 'esDeleteUserData',
      component: esDeleteUserData
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice
    },
    {
      path: '/brandHKNew',
      name: 'brandHKNew',
      component: brandHKNew
    },
    {
      path: '/polPlan',
      name: 'polPlan',
      component: polPlan
    },
    {
      path: '/usPlan',
      name: 'usPlan',
      component: usPlan
    },
    {
      path: '/esContactUs',
      name: 'esContactUs',
      component: esContactUs
    },
    {
      path: '/realNameInfo',
      name: 'realNameInfo',
      component: realNameInfo
    },
    {
      path: '/WhatsAppJumpTo',
      name: 'WhatsAppJumpTo',
      component: WhatsAppJumpTo
    },
    {
      path: '/FacebookJump',
      name: 'FacebookJump',
      component: FacebookJump
    },
    {
      path: '/WechatJump',
      name: 'WechatJump',
      component: WechatJump
    },
    {
      path: '/RussianJump',
      name: 'RussianJump',
      component: RussianJump
    },
    {
      path: '/WeChatBussinessJump',
      name: 'WeChatBussinessJump',
      component: WeChatBussinessJump
    }
  ]
}

Vue.use(Router)

export default new Router(appRouter)



// WEBPACK FOOTER //
// ./src/router/router.js